<template>
  <div>
    <div class="modal fade in" id="mpHistory">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title"><i class="fa fa-info-circle mr-5"></i>Marktplatzhistorie</h4>
          </div>
          <div class="callout callout-info no-margin">
            <h5 class="no-margin">Filialnummer: {{ selectedStore }}</h5>
          </div>
          <div class="modal-body no-padding">
            <div class="nav-tabs-custom row no-margin no-shadow">
              <ul class="nav nav-pills nav-stacked col-md-4 col-sm-5 col-xs-4 no-padding">
                <li :class="{active: index === selectedIndex}" v-for="(channel, key, index) in storeHistory">
                  <a :href="`#history-${index}`" data-toggle="tab" aria-expanded="true" @click="selectedIndex = index">
                    {{ key | translate}}
                  </a>
                </li>
              </ul>
              <div class="tab-content col-md-8 col-sm-7 col-xs-8 no-padding">
                <div :id="`history-${index}`" :class="{'tab-pane': true,  active: index === selectedIndex}" v-for="(channel, key, index) in storeHistory">
                  <div class="box-body" style="max-height:375px;overflow:scroll;">
                    <div :class="['alert alert-warning', storeHistory[key].filter(h => h.changed_to === 1).length > 0 ? 'hidden' : '']">
                      <h4><i class="icon fa fa-warning"></i> Info!</h4>
                      Marktplatz wurde noch nie aktiviert.
                    </div>
                    <ul class="list-group list-group-unbordered">
                      <li class="list-group-item" v-for="history in storeHistory[key]">
                        <strong>{{ history.created_at | orderDateApi }} </strong><small class="text-muted"><i class="fa fa-clock-o mr-5"></i>{{ history.created_at |orderDateApi(true) }}</small><br>
                        <span :class="[history.changed_to === 1 ? 'text-success' : 'text-danger']">{{history.changed_to === 1 ? 'Aktivierung' : 'Deaktivierung'}}</span> durch: {{ history.user }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-right" data-dismiss="modal"><i class="fa fa-times mr-5"></i>Schliessen</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title"><i class="fa fa-map-marker mr-5"></i>{{'stores' | translate}}</h3>
          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
          </div>
        </div>
        <div class="box-controls">
          <button type="button" data-toggle="modal" data-target="#bulk-update-modal" class="btn btn-info">
            <i class="fa fa-cog mr-5"></i>Alle Filialen bearbeiten</button>
        </div>
        <div class="box-body">
          <!-- STORE -->
          <template v-for="item in pagination">
            <store-table-row v-if="typeof storeData[item.store_number] !== 'undefined'" :item="item" :store-data="formattedStoreData(storeData[item.store_number])"  :additionalMarketplaces="additionalMarketplaces" :company="id" @history="getStoreHistory" @updateMp="updateStoreMpVisibility"></store-table-row>
          </template>
          <!-- END STORE -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import StoreTableRow from "../TableRows/StoreTableRow";
  export default {
    components: {StoreTableRow},
    props: ['id', 'pagination', 'storeData', 'loading', 'additionalMarketplaces'],
    data () {
      return {
        count: 25,
        stores: {},
        alerts: [],
        selectedIndex: 0,
        selectedStore: '',
        storeHistory: {},
        isActive: ''
      }
    },
    methods: {
      updateStoreMpVisibility (data) {
        this.$emit('loadingSingleUpdate', data)
      },
      toggleActivation (value, id, index) {
        let data = {
          is_active: value
        }
        this.pagination[index].is_active = value
        API.put(`accounting/companies/${this.id}/stores/${id}`, data)
          .then(response => {
        })
      },
      toggleShowInList(value, id, index) {
        let data = {
          show: value
        }
        this.pagination[index].show_in_list = value
        API.put(`accounting/companies/${this.id}/stores/${id}/showHide`, data)
          .then(response => {
          })
      },
      getStoreHistory (id) {
        //WHEN WE GO LIVE-STAGING WE WILL USE THIS
       API.get(`/accounting/history/${id}`)
        .then(response => {
          this.selectedStore = id
          this.storeHistory = response.data
        })
      },
      formattedStoreData(store) {
        let obj = {}
        Object.keys(store).forEach(k => {
          if (['store_number', 'store_name', 'organisation_number', 'company_name', 'company_id'].indexOf(k) === -1) {
            obj[k] = store[k]
          }
        })
        return obj
      }
    },
    mounted() {
      this.$nextTick(() => {
      })
    },
    watch: {
      storeData() {}
    }
  }
</script>
<style>
  .loading-gif {
    padding-top: 8px;
    padding-bottom: 15px;
    width: 15%;
  }
</style>



// WEBPACK FOOTER //
// src/components/tools/Tables/StoresTable.vue